/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BotExamVisualizationTranslationViewModel } from "../types/BotExamVisualizationTranslationViewModel.ts";
import { botExamVisualizationOptionViewModelSchema } from "./botExamVisualizationOptionViewModelSchema.ts";

export const botExamVisualizationTranslationViewModelSchema = z.object({
  cultureInfo: z
    .string()
    .describe("Código de cultura do idioma desta tradução (ex: en-US, es-ES).")
    .nullish(),
  label: z
    .string()
    .describe("Enunciado da questão traduzido e decodificado. Opcional.")
    .nullish(),
  transcriptExcerpt: z
    .string()
    .describe("Trecho da transcrição traduzido. Opcional.")
    .nullish(),
  explanation: z
    .string()
    .describe("Explicação da resposta correta traduzida. Opcional.")
    .nullish(),
  options: z
    .array(z.lazy(() => botExamVisualizationOptionViewModelSchema))
    .describe(
      "Alternativas da questão no idioma desta tradução, ordenadas por ID.",
    )
    .nullish(),
}) as unknown as ToZod<BotExamVisualizationTranslationViewModel>;
